import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { animation, colors } from '../styles';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

const Card = props => {
  const { className, children } = props;

  return <StyledCard className={className}>{children}</StyledCard>;
};

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.pureWhite};
  transition: background-color ${animation.general.durationAndTiming};

  h5,
  p,
  a,
  svg {
    transition: color ${animation.general.durationAndTiming};
  }

  &:hover {
    background-color: ${colors.cardBackgroundHover};

    h5,
    p,
    a,
    svg {
      color: ${colors.pureWhite};
    }
  }
`;

Card.propTypes = propTypes;

export { Card };
